import React from 'react';
import { Outlet } from 'react-router';
import NotificationSystem from '@/Components/NotificationSystem/NotificationSystem';
import StripeInitialization from '@/Initialization/StripeInitialization';
import { DownloadReportStatusContext } from './UseDownloadReportStatusContext';
import useDownloadReportStatusContextValue from './UseDownloadReportStatusContextValue';
import useUserSignupNavigationContextValue from './UseUserSignupNavigationContextValue';
import { UserProvider } from './UserContext';
import { UserSignupNavigationContext } from './UserSignupNavigationContext';
import SWRConfig from './SWRConfig/SWRConfig';

function RecruiterApplicationContextProvider() {
    const userSignupNavigationContextValue = useUserSignupNavigationContextValue();
    const downloadReportStatusContextValue = useDownloadReportStatusContextValue();

    return (
        <UserProvider>
            <StripeInitialization>
                <NotificationSystem>
                    <SWRConfig>
                        <UserSignupNavigationContext.Provider value={userSignupNavigationContextValue}>
                            <DownloadReportStatusContext.Provider value={downloadReportStatusContextValue}>
                                <Outlet />
                            </DownloadReportStatusContext.Provider>
                        </UserSignupNavigationContext.Provider>
                    </SWRConfig>
                </NotificationSystem>
            </StripeInitialization>
        </UserProvider>
    );
}

export default RecruiterApplicationContextProvider;
